"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
class Search {
}
exports.Search = Search;
//# sourceMappingURL=search.model.js.map